import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useLocation } from "react-router-dom"
import PropTypes from 'prop-types'
import { ThemeProvider } from '@mui/material/styles'
import { PostLoginReportsV2 } from '../../layout'
import { Loader, IsLocalHost, TourGuide } from '../../components'
import {
  removeSpecialCharFromLhs,
  showCustomDevTool,
  getLogData,
  removeCharFromLhsAndTabs,
  fakeDelay,
} from '../../util'
import { EXPORT_PPT, isProd, isLocalHost } from '../../constants'
import { lightTheme } from '../../theme'

import {
  ReportStudySetup1,
  ReportStudySetup2,
  ReportBusiness,
  ReportSnapshot,
  ReportGenerative,
  ReportResearch,
  ReportBrandImagery,
  ReportLandScape,
  ReportLandScapeBrandImagery,
  ReportDeepDiveNew,
  ReportDeepDiveNewV2,
  ReportRecommendations,
  ReportCustomImage,
  ReportKeyTakeaways,
  ReportImpactDestination,
  ReportBrandAttributeMapElement,
  ReportFactorInterLinkageV2,
  ReportBrandImageryGraphLevel2AndProgressionGraph,
  ReportsCampaignOverviewV2,
  ReportAura,
  ReportAuraV2,
  ReportBrandHealthOverviewAndProgression,
  ReportSandboxV2,
  ReportBrandMagnetScore,
  ReportSandbox,
  ReportBrandMagnetScoreAndProgression,
  ReportBuzzMetrics,
  ReportCampaignOverview,
  ReportSegment,
  ReportSegmentV2,
  RelativeBrandsAnalysis,
  BuyerMaturityByAge,
  BuyerMaturityByAgeProgression,
  CampaignSegmentsEngagementOverview,
  CampaignSegmentsEngagementProgression,
  CompetitionConsideration,
  ReportMining,
  ReportSegmentAndSegmentOfSegment,
  ReportSegmentAndSegmentOfSegmentV2,
  MultiBrandNPS,
  ReportTabsPptSlide,
  ReportCategoryPersona,
  ReportCategoryPersonaV2,
  ComparisonViewDeepDive,
  ComparisonViewDeepDiveV2,
  ComparisonViewDeepDiveV22,
  ComparisonViewDeepDiveNew,
  ReportCustomTable,
  SegmentOverview,
  SegmentComparison,
  SegmentProgression
} from './components'

import Tabs from './tabs'
import HeaderButtons from './headerButtons/headerButtons'

import {
  ContentInnerWrapper,
  ContentWrapper,
  ReportPageLoader,
  PptLoadingStatus,
  CsvLoadingStatus,
  DeveloperWrapper,
  AskAIDetailHeader,
  SnapshotDetailHeader,
  AskIaLayoutOuterWrapper
} from './style'

import { useGlobalStore } from '../../store'
import { Backdrop, Box, IconButton, Typography, Button } from '@mui/material'
import IconClosePlain from '../../assets/images/icons/icon-close-plain'
import AskIaLayout from '../../layout/askIaLayout/askIaLayout'
import { ArrowBackIos } from '@mui/icons-material'

const Reports = () => {
  const observerRef = useRef(null)
  const {
    subLhs,
    loadAllLhs,
    setLoadAllLhs,
    csvSubLhs,
    pptSubLhs,
    pptSubLhsAppendices,
    pptSubLhsProgression,
    isPPTModalActive,
    isAskIaActiveState,
    isSnapshotActiveState,
    isCSVModalActive,
    isAskIAModalActive,
    isSnapshotModalActive,
    hasSnapshotData,
    setSnapshotData
  } = useGlobalStore()
  const [lhsLoading, setLhsLoading] = useState(false)
  const [subLhsData, setSubLhsData] = useState([])

  const isAskIaActiveStateObj = isAskIaActiveState.split('___')
  const isSnapshotActiveStateObj = isSnapshotActiveState.split('___')

  /*
  useEffect(() => {
    const timeout = setTimeout(() => {
      const elements = document.querySelectorAll('.pageRoot')
      if (window.IntersectionObserver) {
        observerRef.current = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const elms = document.querySelectorAll('.l2TabLink')
                elms.forEach((els) => els.classList.remove('active'))
                const el = document.querySelector(`.id_${entry.target.id}`)
                if (el) {
                  el.classList.add('active')
                }
              }
            })
          },
          { rootMargin: '0px 0px -80% 0px' }
        )
        elements.forEach((section) => {
          observerRef.current.observe(section)
        })
      }
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [subLhs])
  */

  const onChangeHandler = (param) => {
    setLhsLoading(param.lhsLoading)
  }

  useEffect(() => {
    if (!!subLhs?.length && !!loadAllLhs?.length && !lhsLoading) {
      setTimeout(() => {
        setLoadAllLhs([])
      })
    }
  }, [subLhs, loadAllLhs, lhsLoading, setLoadAllLhs])

  useEffect(() => {
    if (subLhs?.length) {
      setSubLhsData([])
    }
  }, [subLhs])

  useEffect(() => {
    if (!!subLhs?.length && subLhsData?.length === 0) {
      setSubLhsData(subLhs)
    }
  }, [subLhsData, subLhs])

  useEffect(() => {
    if (subLhs?.length && subLhsData?.length) {
      const data = [...subLhsData, ...subLhs].filter(f => f.InsightsElementType === 'Snapshot')
      // Only update if we found snapshot data and it's different from what we have
      if(data?.[0] && (!hasSnapshotData || hasSnapshotData.InsightsElementId !== data[0].InsightsElementId)) {
        setSnapshotData(data[0])
        window.localStorage.setItem('hasSnapshotData',JSON.stringify(data[0]))
      }

    }
  }, [subLhsData, subLhs])

  useEffect(() => {
    if(!hasSnapshotData){
      const d = JSON.parse( localStorage.getItem('hasSnapshotData') )
      setSnapshotData(d)
    }
  }, [isSnapshotModalActive, hasSnapshotData])

  return (
    <PostLoginReportsV2 onChange={onChangeHandler} actions={<HeaderButtons />} page={'reportPage'}>
      {subLhsData?.length === 0 && <Loader />}

      {isAskIAModalActive && <ReportGenerative type={'InsightsElementTypeQnA'} />}
      {isSnapshotModalActive && hasSnapshotData && <ReportSnapshotWrapper />}

      {isCSVModalActive &&
        isAskIaActiveState === 'none' &&
        isSnapshotActiveState === 'none' &&
        [...csvSubLhs].length > 0 &&
        !lhsLoading && (
          <ReportComponents
            isPPTModalActive={false}
            isCSVModalActive={true}
            csvSubLhs={[...csvSubLhs]}
            pptSubLhs={null}
            subLhs={null}
            lhsLoading={lhsLoading}
            loadOnlyApi={false}
            key={0}
          />
        )}

      {!isCSVModalActive &&
        [...subLhs, ...pptSubLhs, ...pptSubLhsAppendices, ...pptSubLhsProgression].length > 0 && (
          <>
            {isAskIaActiveState === 'none' && isSnapshotActiveState === 'none' && !!subLhsData?.length && !lhsLoading && (
              <ReportComponents
                isPPTModalActive={isPPTModalActive}
                isCSVModalActive={false}
                pptSubLhs={[...pptSubLhs, ...pptSubLhsAppendices, ...pptSubLhsProgression]}
                subLhs={subLhsData}
                lhsLoading={lhsLoading}
                loadOnlyApi={false}
                key={0}
              />
            )}
            {!['none', 'active'].includes(isAskIaActiveState) && (
              <ReportComponents
                isAskIaActiveState={isAskIaActiveState}
                isPPTModalActive={false}
                isCSVModalActive={false}
                pptSubLhs={[...pptSubLhs, ...pptSubLhsAppendices, ...pptSubLhsProgression]}
                subLhs={[
                  {
                    InsightsElementId: isAskIaActiveStateObj[0],
                    InsightsElementType: isAskIaActiveStateObj[1],
                    Title: isAskIaActiveStateObj[2],
                    EntityId: isAskIaActiveStateObj[3],
                    NewPeriod: isAskIaActiveStateObj[4],
                    askIa:true
                  },
                ]}
                lhsLoading={lhsLoading}
                loadOnlyApi={false}
                key={0}
              />
            )}
            {!['none', 'active'].includes(isSnapshotActiveState) && (
              <ReportComponents
                isSnapshotActiveState={isSnapshotActiveState}
                isPPTModalActive={false}
                isCSVModalActive={false}
                pptSubLhs={[...pptSubLhs, ...pptSubLhsAppendices, ...pptSubLhsProgression]}
                subLhs={[
                  {
                    InsightsElementId: isSnapshotActiveStateObj[0],
                    InsightsElementType: isSnapshotActiveStateObj[1],
                    Title: isSnapshotActiveStateObj[2],
                    EntityId: isSnapshotActiveStateObj[3],
                    NewPeriod: isSnapshotActiveStateObj[4],
                  },
                ]}
                lhsLoading={lhsLoading}
                loadOnlyApi={false}
                key={0}
              />
            )}
          </>
        )}

      <IsLocalHost>
        <PptLoadingStatus id='pptLoadingStatus'>
          Component loaded(<strong>0</strong>) :---
          <br />
          <ol></ol>
          <br />
          Images Loaded(<b>0</b>) <br />
          <span></span>
          <div id='timeStartEnd'></div>
        </PptLoadingStatus>
        <CsvLoadingStatus id='csvLoadingStatus'>
          Component loaded(Current:<strong id='current'>0</strong> - Total:
          <strong id='total'>0</strong>) :---
          <br />
          List
          <br />
          <ol></ol>
        </CsvLoadingStatus>
      </IsLocalHost>
    </PostLoginReportsV2>
  )
}

const ReportComponents = ({
  subLhs,
  pptSubLhs,
  csvSubLhs,
  isPPTModalActive,
  isCSVModalActive,
  lhsLoading,
  loadOnlyApi,
}) => {
  const {
    isTourGuideActive,
    isAskIaActiveState,
    setAskIaActiveState,
    isSnapshotActiveState,
    setSnapshotActiveState,
    isFullScreen,
    projectIdValue,
    setAskIAModalActive,
    isAskIAModalActive,
    setShowLhsMenu,
    isSnapshotModalActive
  } = useGlobalStore()
  // const [minHt, setMinHt] = useState()

  const [headerData, setHeaderData] = useState(null)
  const [askIaInsightsId, setAskIaInsightsId] = useState(null)
  let previousTabId = 0
  const onlyOneComponent = subLhs?.length === 1 ? 'onlyOneComponent' : ''
  const askIaDetailPage = isAskIaActiveState !== 'none' ? 'askIaDetailPage' : ''
  const snapshotDetailPage = isSnapshotActiveState !== 'none' ? 'snapshotDetailPage' : ''
  const isAppendicesArray = []
  const isProgressionArray = []
  
  const history = useHistory()
  const location = useLocation()

  const reorderingForExportToPptFunc = (list) => {
    const deepDiveProgression = EXPORT_PPT.deepDiveSegmentsProgression
    const appendices = list.filter(
      (a) => !deepDiveProgression.includes(a.InsightsElementTypeAppendices)
    )
    const progression = list.filter((a) =>
      deepDiveProgression.includes(a.InsightsElementTypeProgression)
    )
    return [...appendices, ...progression]
  }

  ////////////////////////////////////////////////////
  ////////////////////////////////////////////////////
  /* */
  const rhsSticky = (wrapper, stickyEl) => {
    const wrapperRect = wrapper.getBoundingClientRect()
    const stickyRect = stickyEl?.getBoundingClientRect() || null
    // const windowHeight = window.innerHeight // 59
    const windowHeight = window.innerHeight // 119

    if (isNaN(stickyRect)) {
      if (wrapperRect.height > windowHeight - 140) {
        if (wrapperRect.bottom < windowHeight) {
          stickyEl.classList.add('bottom')
          stickyEl.classList.remove('fixed')
        } else if (wrapperRect.top < -40) {
          stickyEl.classList.add('fixed')
          stickyEl.classList.remove('bottom')
        } else if (stickyRect.top - 45 <= wrapperRect.top) {
          stickyEl.classList.remove('fixed')
          stickyEl.classList.remove('bottom')
        }
      }
    }
  }

  const addingOnScrollFunc = () => {
    const moveInsightsToRight = document.querySelectorAll('.moveInsightsToRight')
    for (let i = 0; i < moveInsightsToRight.length; i++) {
      const stickySidebar = moveInsightsToRight[i].querySelector('.stickySidebar')
      if (isNaN(stickySidebar)) {
        rhsSticky(moveInsightsToRight[i], stickySidebar)
      }
    }
  }

  useEffect(() => {
    // setTimeout(() => {
    //   if (document.querySelector('.rhsContent'))
    //     document.querySelector('.rhsContent').addEventListener('scroll', addingOnScrollFunc)
    // }, 5000)
    // window.addEventListener('resize', addingOnScrollFunc)
  }, [])
  /* */
  ////////////////////////////////////////////////////
  ////////////////////////////////////////////////////

  const addingOnScrollOnReportsContentSectionFunc = () => {
    const breadCrumb = document.getElementById('breadCrumbLevel2')
    const scrollContainer = document.getElementById('reportsContentSection') // ('scroll-container')
    const links = document.querySelectorAll('.nav-link') // ('.nav-link')
    const sections = Array.from(document.querySelectorAll('.pageRoot')) // ('.section'))

    if (breadCrumb && scrollContainer && links && sections) {
      const attributesObjectFunc = (div) => {
        return Array.from(div.attributes).reduce((obj, attr) => {
          obj[attr.name] = attr.value
          return obj
        }, {})
      }

      const addActiveClassToLHS = (node) => {
        const brudCrumLevel2 = document.querySelector('#breadCrumbLevel2')
        const sectionObject = node ? attributesObjectFunc(node) : {}
        breadCrumb.innerText =
          sectionObject?.['data-parenttitle'] !== ''
            ? sectionObject?.['data-parenttitle'] || ''
            : sectionObject?.['data-title'] || ''
        if (brudCrumLevel2.dataset.tabname === 'Sandbox') {
          breadCrumb.innerText = ''
        }
        const lhs = document.querySelectorAll('.lhsWrapper .lhsLevel2 a')
        const content = [sectionObject['data-title'], sectionObject['data-parenttitle']]
        for (let i = 0; i < lhs.length; i++) {
          lhs[i].classList.toggle('active', content.includes(lhs[i].innerText))
        }
      }

      function updateActiveLink() {
        const scrollTop = scrollContainer.scrollTop
        const current = sections.find((section) => {
          addActiveClassToLHS(section.querySelector('.headingRte'))
          //
          const top = section.offsetTop - 200
          const bottom = top + section.offsetHeight
          return scrollTop >= top - 10 && scrollTop < bottom - 10
        })

        if (current) {
          links.forEach((link) => {
            link.classList.toggle('active', link.dataset.target === current.id)
            link.parentNode.classList.remove('sticky')
          })
          for (let i = 0; i < links.length; i++) {
            if (links[i].classList.contains('active')) {
              links[i].parentNode.classList.add('sticky')
              break
            }
          }
        }
      }

      // let scrollTimeout
      // scrollContainer.addEventListener('scroll', updateActiveLink);
      // scrollContainer.addEventListener('scroll', () => {
      //   clearTimeout(scrollTimeout);
      //   scrollTimeout = setTimeout(() => {
      //     updateActiveLink()
      //   }, 20);
      // })

      updateActiveLink()
    }
  }

  useEffect(() => {
    if (!isCSVModalActive && !isPPTModalActive) {
      // addingOnScrollOnReportsContentSectionFunc()
    }
  }, [])

  ////////////////////////////////////////////////////
  ////////////////////////////////////////////////////

  const getSubLhsArray = () => {
    if (isPPTModalActive) return reorderingForExportToPptFunc(pptSubLhs)
    else if (isCSVModalActive) return csvSubLhs
    return subLhs
  }

  const closeAskIaDetailPage = () => {
    const params = new URLSearchParams(location.search);
    const insightId = params.get('askiaInsightsId')
    if (insightId) {
      setAskIAModalActive(false)
      setShowLhsMenu('reportPage_showLhs')
      params.delete("askiaInsightsId");
    }

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
    
    setAskIaActiveState('none')
  }

  const closeSnapshotDetailPage = () => {
    setSnapshotActiveState('none')
  }

  const getHeaderInfo = () => {
    const headerLogData = projectIdValue.ProjectId
      ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: projectIdValue.ProjectId })[0]
      : {}

    const headerObj = {
      // isFreezed: projectIdValue.IsFreezed,
      // isPublished: projectIdValue.IsPublished,
      studyId: projectIdValue?.StudyId || '',
      brandName: headerLogData?.BrandName || '',
      breadCrumb: headerLogData?.ProjectType || '',
      projectType: `${headerLogData?.ProjectType || ''}, ${headerLogData?.MarketName || ''}`,
      // subTitle: `${headerLogData.MarketName} | ${headerLogData.ProjectFrequency} | ${projectIdValue.Period}`,
      subTitle: projectIdValue?.Period || '',
    }

    setHeaderData(headerObj)
  }

  useEffect(() => {
    if(isAskIaActiveState !== 'none'){
      if(headerData && headerData?.studyId === ''){
        getHeaderInfo()
      }
    }
  }, [isAskIaActiveState, headerData])

  useEffect(() => {
    getHeaderInfo()
  }, [])

  const removeActiveClass = (ele, className) => {
    if (ele) {
      const parentEle = [...ele.parentElement.children]
      parentEle.forEach((element) => element.classList.remove(className))
    }
  }

  const prevScrollY = { current: 0 }
  const getDirectionDetails = () => {
    const currentScrollY = document.getElementById('reportsContentSection').scrollTop
    const prevScrollY_current = prevScrollY.current
    prevScrollY.current = currentScrollY
    if (currentScrollY > prevScrollY_current) {
      return 'down'
    } else if (currentScrollY < prevScrollY_current) {
      return 'up'
    }
    return 'still'
  }

  const intersectionObserverIsIntersectingFunc = (ele) => {
    if (isPPTModalActive || isCSVModalActive || isAskIaActiveState !== 'none' || isSnapshotActiveState !== 'none') return false

    ele.classList.add('visiblePageSection')
    const headingRte = ele.querySelector('.headingRte')
    const heading1 = headingRte?.getAttribute('data-title') || null
    const heading2 = headingRte?.getAttribute('data-parenttitle') || null
    const brudCrumLevel2 = document.querySelector('#breadCrumbLevel2')

    brudCrumLevel2.textContent = heading2 || heading1
    if (brudCrumLevel2.dataset.tabname === 'Sandbox') {
      brudCrumLevel2.textContent = ''
    }

    const lhs = document.querySelectorAll('.lhsWrapper .lhsLevel2 a')
    lhs.forEach((eleA) =>
      [heading1, heading2].includes(eleA.textContent)
        ? eleA.classList.add('active')
        : eleA.classList.remove('active')
    )

    document.querySelectorAll('.tab-sticky').forEach((tabEle) => tabEle.classList.remove('active'))
    document.querySelectorAll('.tab-sticky').forEach((tabEle) => (tabEle.style.display = 'block'))
    if (heading2) {
      const tabEle = document.querySelector(
        `.tab-sticky[data-tabparent="${removeCharFromLhsAndTabs(heading2)}"]`
      )
      if (tabEle) {
        tabEle.classList.add('active')
        const lhsEle = document.getElementById(tabEle.id)
        if (lhsEle) {
          removeActiveClass(lhsEle, 'active')
          lhsEle.classList.add('active')
        }
      }

      const tabHt = tabEle?.getBoundingClientRect()?.height || 0
      const rhsEle = ele.querySelector('.stickySidebarDefault') // THIS LINE FOR MAKING RHS STICKY WITH LEVEL3
      const customTableEle = ele.querySelector('thead') // THIS LINE FOR MAKING CUSTOMTABLE HEADER STICKY WITH LEVEL3
      const hasH4Height = tabEle?.classList?.contains('first-tab') ? 0 : 44 // THIS 44PX IS FOR H4 HEIGHT, WHICH IS SHOWN IF LENGTH IS GRATER THAN 1
      if (rhsEle) {
        rhsEle.style.top = `${tabHt - hasH4Height}px`
      }
      if (customTableEle) {
        customTableEle.style.top = `${tabHt - hasH4Height}px`
      }

      const innerTabEle = document.querySelector(`[data-target="${ele.id}"]`)
      if (innerTabEle) {
        removeActiveClass(innerTabEle, 'active')
        innerTabEle.classList.add('active')
      }
    }
  }

  const onScrollPageFunc = async () => {
    let totalElementsHeight = 0

    document.getElementById('reportsContentSection').addEventListener('scroll', (e) => {
      const elements = document
        .getElementById('reportsContentSection')
        .querySelectorAll('.reportOuterWrapper.pageRoot')
      totalElementsHeight = 0
      for (let i = 0; i < elements.length; i++) {
        totalElementsHeight = Math.round(
          totalElementsHeight + elements[i].getBoundingClientRect().height
        )
      }

      elements.forEach((entry, i) => {
        // const entryTop = entry.getBoundingClientRect().top - (55 + 55); // 56 & 56 is the height of the headers
        // const entryBottom = entry.getBoundingClientRect().bottom - (55 + 55); // 56 & 56 is the height of the headers
        const entryTop = entry.getBoundingClientRect().top - (55 + 55 + 80) // 56 & 56 is the height of the headers
        const entryBottom = entry.getBoundingClientRect().bottom - (55 + 55 + 80) // 56 & 56 is the height of the headers
        if ((entryTop > 0 && entryTop < 50) || (entryTop < 0 && entryBottom > 0)) {
          intersectionObserverIsIntersectingFunc(entry)
        }
      })

      if (
        e.target.scrollTop > 100 &&
        e.target.scrollTop + e.target.getBoundingClientRect().height > totalElementsHeight - 50
      ) {
        // Adding 50px will change the active state of the section
        // if(e.target.scrollTop > 100 && (e.target.scrollTop + e.target.getBoundingClientRect().height) > (totalElementsHeight-0)){
        // reached at the end of the page
        const lhs = document.querySelectorAll('.lhsWrapper .lhsLevel2 a')
        lhs.forEach((eleA, i) => {
          eleA.classList.remove('active')
          if (lhs.length - 1 === i) {
            eleA.classList.add('active')
          }
        })
      }

      // document.getElementById('tabLevel3').innerHTML = document.querySelector('.tab-sticky.active').innerHTML
      // document.querySelector('.tab-sticky.active').style.display = 'none'
      // document.querySelectorAll('#tabLevel3 a').forEach((aTag) => {
      //   aTag.setAttribute('data-target','none')
      // })
    })

    const firstElement = document
      .getElementById('reportsContentSection')
      .querySelectorAll('.reportOuterWrapper.pageRoot')[0]
    intersectionObserverIsIntersectingFunc(firstElement)
    document.getElementById('reportsContentSection').classList.add('componentIsLoading')
    onLoadFunc()
  }

  const onLoadFunc = async () => {
    // SCROLLING ADJUSTMENT1
    let loaderLen = document.querySelectorAll('.rhsContent .loadingWrapper').length
    await fakeDelay(500)
    if(document.querySelector('.lhsLevel2 a:first-of-type')) {
      document.querySelector('.lhsLevel2 a:first-of-type').click()
    }
    if (loaderLen > 1) {
      onLoadFunc()
    } else {
      await fakeDelay(1000)
      document.getElementById('reportsContentSection').classList.remove('componentIsLoading')
    }
  }

  useEffect(() => {
    if (subLhs?.length > 0) {
      onScrollPageFunc()
    }
  }, [subLhs])

  useEffect(() => {
    // CHECK IF askIaInsightsId IS PRESENT IN URL, IF YES THEN OPEN THE ASKIA DETAIL PAGE
    const params = new URLSearchParams(location.search)
    const insightId = params.get('askiaInsightsId')
    if (insightId) {
      setAskIAModalActive(true)
    }
    setShowLhsMenu('reportPage_hideLhs')
  }, [])

  return (
    <>
      {getSubLhsArray().map((reportList, i) => {
        const list = {
          ...reportList,
          ...{
            loadOnlyApi: loadOnlyApi,
            driversSegmentsExpanded: !!reportList?.InsightsElementTypeAppendices,
            isPPTModalActive: isPPTModalActive,
            isCSVModalActive: isCSVModalActive,
          },
        }

        const isAppendices = list?.InsightsElementTypeAppendices ? 'Appendices__' : ''
        if (isAppendices) isAppendicesArray.push(list)
        const isAppendicesStatus =
          isAppendicesArray?.[0]?.InsightsElementId === list?.InsightsElementId
        list.isAppendicesActive = isAppendices

        const isProgression = list?.InsightsElementTypeProgression ? 'Progression__' : ''
        if (isProgression) isProgressionArray.push(list)
        const isProgressionStatus =
          isProgressionArray?.[0]?.InsightsElementId === list?.InsightsElementId
        list.isProgressionActive = isProgression

        // const listType = `${isAppendices}${isProgression}${list.InsightsElementType}__${list.InsightsElementId.replaceAll('-', '')}__${i}`
        const listType = `${isAppendices}${isProgression}${list.InsightsElementType}__${list.InsightsElementId.replaceAll('-', '')}`
        // const tabIdStatus = previousTabId !== list.TabId ? 'new' : 'old' // USED below

        if (previousTabId !== list.TabId) {
          previousTabId = list.TabId
        }
        const lastPageSection = (i === subLhs?.length - 1 && !isPPTModalActive) ? 'lastPageSection' : ''

        const className_moveInsightsToRight = [
          'BrandHealthSetup',
          'CategoryExplorationSetup',
          'BusinessObjective', // TEMP
          'Snapshot',
          'ProductRatingOptimizationSetup',
        ].includes(list.InsightsElementType)
          ? 'moveInsightsToLeft'
          : 'moveInsightsToRight'

        list.moveInsightsTo = className_moveInsightsToRight

        const showComponents = [
          // 'BusinessObjective',
          // 'SegmentAndSegmentOfSegment',
          // 'SegmentDriversAnalysis',
          // 'DriversProgressionWithoutSentiments',
          // 'SegmentDriversOnlyAnalysisWithoutSentiments',
          // 'SegmentDriversOnlyAnalysisWithoutSentiments3Level',
          // 'SegmentDriversOnlyAnalysis',
          // 'SegmentDriversOnlyAnalysis3Level',
          // 'SegmentOverview',
          // 'BrandImageryMappingAndProgressionGraph', 'BrandImageryMappingGraph', 'Recommendation'
          // 'SegmentAndSegmentProgression'
          // 'SegmentAndSegmentOfSegment'
        
          // 'TriangulationMapAndProgression'
          // 'DriversProgression3Level'

          // 'BrandAttributeMapElement',
          // 'BrandAttributeMapAndProgression',
          // 'TriangulationMapElement',
          // 'TriangulationMapAndProgression',
          // 'TriangulationMapElementLog10',
          // 'TriangulationMapAndProgressionLog10',

          // 'SegmentDriversAnalysis',
          // 'SegmentDriversOnlyAnalysis3Level'

          // 'CategoryPersona'
          
          // 'SegmentOfSegmentOverview',
          // 'SegmentOfSegmentOverviewAndProgression',


          // 'Triangulation', 'TriangulationMapElement', 'TriangulationComparisonViewOnly',
          // 'ImpactDestinations'
          // 'CompetitiveLandscape',
          // 'CompetitiveLandscapeBrandImagery',
          // 'BrandImageryMappingTable',
        ]

        if(isLocalHost){
          if(showComponents.length > 0){
            if(!(showComponents.includes(list.InsightsElementType))) {return false}
          }

          const showComponentsById = [
            // '00000000-0000-0000-0000-000000000000',
            // 'b393c0ee-83c9-423a-9fe0-ccd6414a1352',
            // 'b393c0ee-83c9-423a-9fe0-ccd6414a1352',
            // 'b393c0ee-83c9-423a-9fe0-ccd6414a1352',
          ]
          if(showComponentsById.length > 0){
            if(!(showComponentsById.includes(list.InsightsElementId))) {return false}
          }
        }

        if (showCustomDevTool('dev_report')) {
          // dev_report ["BusinessObjective", "Recommendation"]
          const devReportList = showCustomDevTool('dev_report', list) || []
          const devReportListFlag = devReportList.includes(
            list.InsightsElementType || list.InsightsElementId
          )
          if (!devReportListFlag) {
            return false
          }
        }

        // NOTE: DON'T DELETE THIS BELOW LINE ITS A HACK FIX FOR SEWANTI LOGIN
        if (
          list.InsightsElementType === 'FactorInterlinkage' &&
          list.InsightsElementId === '31d10bb2-2208-11ee-817c-0a1ea4c5532f'
        ) {
          return false
        }

        let parentWrapperStyling = {}
        if ( list.InsightsElementType === 'Snapshot' && !isPPTModalActive) {
          parentWrapperStyling = {padding: 0}
        }

        // if(!['none', 'active'].includes(isAskIaActiveState)){
        //   console.log('NEED TO REDIRECT ... headerData', headerData?.projectType, headerData?.projectType.length)
        //   if( headerData?.projectType.length === 0 ){
        //     console.log('NEED TO REDIRECT FROM REPORT PAGE')
        //   }
        // }

        return (
          <React.Fragment key={i}>
            {!(isPPTModalActive || isCSVModalActive) &&
              list.ParentTitle !== '' &&
              list.ParentTitleIndex === 0 &&
              list.ParentTitleArray?.length > 0 && (
                  <Tabs isFirstTab={i === 0} data={list.ParentTitleArray} obj={list} />
              )}

            {i === 0 && <Backdrop sx={{ zIndex: '50' }} open={!['none', 'active'].includes(isAskIaActiveState)}></Backdrop>}
            {i === 0 && <Backdrop sx={{ zIndex: '50' }} open={!['none', 'active'].includes(isSnapshotActiveState)}></Backdrop>}

            <ContentInnerWrapper
              className={`reportOuterWrapper pageRoot ${lastPageSection} ${askIaDetailPage} ${snapshotDetailPage} ${onlyOneComponent} ${isPPTModalActive && 'isPPTModalActive'} ${isCSVModalActive && 'isCSVModalActive'} ${list.InsightsElementType === 'CompetitiveLandscape' ? 'Competitive-landScape-Wrapper' : ''}`}
              key={i}
              id={`id_${removeSpecialCharFromLhs(list.Title)}_${list.InsightsElementId.replaceAll('-', '')}`}
              style={parentWrapperStyling}
            >

              {lhsLoading && (
                <ContentWrapper sx={{ minHeight: '600px' }}>
                  <Loader />
                </ContentWrapper>
              )}
              {i === 0 && (
                <ReportPageLoader className='reportPageLoader'>
                  <Loader />
                </ReportPageLoader>
              )}

              {!['none', 'active'].includes(isAskIaActiveState) && (
                <AskAIDetailHeader>
                  <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    {headerData?.studyId && <>
                      {headerData?.brandName && <Typography sx={{}} className='phase-year'>
                        {headerData?.brandName}
                      </Typography>}
                      <Typography sx={{}} className='phase-year'>
                        {headerData?.projectType}
                      </Typography>
                      <Typography className='phase-year'>
                        {subLhs?.[0]?.NewPeriod || headerData?.subTitle}
                      </Typography>
                    </>}
                  </Box>
                  <IconButton className='closeIcon' onClick={closeAskIaDetailPage}>
                    <IconClosePlain />
                  </IconButton>
                </AskAIDetailHeader>
              )}

              {!['none', 'active'].includes(isSnapshotActiveState) && (
                <SnapshotDetailHeader>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <Typography sx={{}} className='phase-year'>
                      {headerData?.brandName}
                    </Typography>
                    <Typography sx={{}} className='phase-year'>
                      {headerData?.projectType}
                    </Typography>
                    <Typography className='phase-year'>
                      {subLhs?.[0]?.NewPeriod || headerData?.subTitle}
                    </Typography>
                  </Box>
                  <IconButton className='closeIcon' onClick={closeSnapshotDetailPage}>
                    <IconClosePlain />
                  </IconButton>
                </SnapshotDetailHeader>
              )}


              <ThemeProvider theme={lightTheme}>
                {/* IMPORTANT NOTE: THE ABOVE <ThemeProvider /> WRAPPER CONTROLLER NOT TO APPLY DARK THEME ON ANY CHILD.. ISSUE FIXED IN ASKIA DARK THEM MODE */}
              {!lhsLoading && (
                <ContentWrapper
                  className={`${!isFullScreen && className_moveInsightsToRight} ${isPPTModalActive ? 'isPPTModalActiveTrue' : 'isPPTModalActiveFalse'} ${isCSVModalActive ? 'isCSVModalActiveTrue' : 'isCSVModalActiveFalse'}`}
                >
                  {list.InsightsElementType !== 'QnA' && (
                    <IsLocalHost>
                      <DeveloperWrapper show={true}>
                        {list?.isFreezed && <div style={{width:'100px', color: 'green' }}>isFreezed</div>}
                        {!list?.isFreezed && <div style={{width:'100px', color: 'red' }}>notFreezed</div>}
                        <div><b>InsightsElementType</b> <span>{list.InsightsElementType}</span></div>
                        <div><b>InsightsElementId</b> <span>{list.InsightsElementId}</span></div>
                        <div><b>TabId</b> <span>{list.TabId}</span></div>
                      </DeveloperWrapper>
                    </IsLocalHost>
                  )}

                  {/* {list.InsightsElementType !== 'QnA' && <>
                  <div><b>InsightsElementType = {list.InsightsElementType}</b></div>
                  </>} */}

                  {/* {list.InsightsElementType !== 'QnA' && <b>InsightsElementType = {list.InsightsElementType}</b>} */}
                  {isAppendicesStatus && isPPTModalActive && (
                    <ReportTabsPptSlide
                      type={`reportAppendices__${listType}`}
                      {...list}
                      slideType='appendices'
                    />
                  )}
                  {isProgressionStatus && isPPTModalActive && (
                    <ReportTabsPptSlide
                      type={`reportProgression__${listType}`}
                      {...list}
                      slideType='progression'
                    />
                  )}
                  {/* {tabIdStatus === 'new' && isPPTModalActive && <ReportTabsPptSlide type={`reportTabs__${listType}`} {...list} slideType='tabs' />} */}

                  {!isPPTModalActive && list.InsightsElementType === 'FactorInterlinkage' && (
                    <ReportFactorInterLinkageV2 type={listType} {...list} />
                  )}

                  {['ImpactDestinations', 'ImpactDestinationsAndProgression'].includes(list.InsightsElementType) && (
                    <ReportImpactDestination type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'AllRelativeBrandsAnalysis20Colors' && (
                    <RelativeBrandsAnalysis isExtraColor type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'SegmentOfSegmentOverview20Colors' && (
                    <BuyerMaturityByAge isExtraColor type={listType} {...list} />
                  )}
                  {list.InsightsElementType === 'BusinessObjective' && (
                    <ReportBusiness type={listType} {...list} />
                  )}

                  {!isSnapshotModalActive && isPPTModalActive && list.InsightsElementType === 'Snapshot' && (
                    <ReportSnapshot type={listType} {...list} visibility='hidden' />
                  )}

                  {!isPPTModalActive && list.InsightsElementType === 'ResearchDesign' && (
                    <ReportResearch type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'CampaignAndIssuesAssessmentSetup' && (
                    <ReportStudySetup2 type={listType} {...list} />
                  )}

                  {!isPPTModalActive && [
                    'Aura', 
                    'AuraAndProgression', 
                    'AuraAndComparison', 
                    'AuraAndProgressionAndComparison' , 
                    'AuraWithoutSentiments', 
                    'AuraWithoutSentimentsAndProgression', 
                    'AuraWithoutSentimentsAndComparison', 
                    'AuraWithoutSentimentsAndProgressionAndComparison']
                    .includes(list.InsightsElementType) && (
                    <ReportAuraV2 type={listType} {...list} />
                  )}

                  {[
                    'BrandHealthSetup',
                    'CategoryExplorationSetup',
                    'ProductRatingOptimizationSetup',
                  ].includes(list.InsightsElementType) && (
                    <ReportStudySetup1 type={listType} {...list} />
                  )}

                  {['BrandImageryMappingAndProgressionGraph', 'BrandImageryMappingGraph'].includes(
                    list.InsightsElementType
                  ) && (
                    <ReportBrandImageryGraphLevel2AndProgressionGraph type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'CampaignTriggers' && (
                    <ReportsCampaignOverviewV2 type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'Sandbox' && (
                    <ReportSandboxV2 type={listType} {...list} />
                  )}

                  {['Recommendation', 'RecommendationAndProgression'].includes(list.InsightsElementType) && (
                    <ReportRecommendations type={listType} {...list} />
                  )}

                  {!isPPTModalActive && [
                    'SearchDrivers',
                    'Drivers',
                    'DriversAndSubBrands',
                    'DriversWithoutSentimentsAndSubBrands',
                    'DriversAndTriggers',
                    'DriversAndRatingImpacts',
                    'DriversWithoutSentiments',
                  ].includes(list.InsightsElementType) && (
                    <ReportDeepDiveNewV2 type={listType} {...list} />
                  )}

                  {!isPPTModalActive && [
                    'DriversMotivatorsDetractors',
                    'DriversAndSubBrandsMotivatorsDetractors',
                    'DriversAndTriggersMotivatorsDetractors',
                    'DriversAndRatingImpactsMotivatorsDetractors',
                  ].includes(list.InsightsElementType) && (
                    <ReportDeepDiveNewV2 motivatorsDetractors={true} type={listType} {...list} />
                  )}

                  {['BrandMagnetScore', 'BrandMagnetScoreAndProgression'].includes(
                    list.InsightsElementType
                  ) && <ReportBrandMagnetScoreAndProgression type={listType} {...list} />}

                  {list.InsightsElementType === 'CompetitiveLandscape' && (
                    <ReportLandScapeBrandImagery type={listType} {...list} />
                  )}
                  {list.InsightsElementType === 'CompetitiveLandscapeBrandImagery' && (
                    <ReportLandScapeBrandImagery type={listType} {...list} />
                  )}
                  {list.InsightsElementType === 'BrandImageryMappingTable' && (
                    <ReportBrandImagery type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'ReportKeyTakeaways' && (
                    <ReportKeyTakeaways type={listType} {...list} />
                  )}
                  {list.InsightsElementType === 'BrandCategoryOverview' && (
                    <ReportBrandHealthOverviewAndProgression type={listType} {...list} />
                  )}
                  {list.InsightsElementType === 'BrandCategoryOverviewAndProgression' && (
                    <ReportBrandHealthOverviewAndProgression type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'BuzzMetrics' && (
                    <ReportBuzzMetrics type={listType} {...list} />
                  )}
                  {list.InsightsElementType === 'ReportCampaignOverview' && (
                    <ReportCampaignOverview type={listType} {...list} />
                  )}

                  {!isPPTModalActive && list.InsightsElementType === 'AllRelativeBrandsAnalysis' && (
                    <SegmentOverview type={listType} {...list} isExtraColor />
                  )}
                  {!isPPTModalActive && list.InsightsElementType === 'SegmentOverview' && (
                    <SegmentOverview type={listType} {...list} isExtraColor /> // Scorpio-N > Brand Pulse, India > Phase 2 FY25 > Customer Profile > Profile > Business Deep Dive [Scorpio-N Owners]
                  )}

                  {!isPPTModalActive && list.InsightsElementType === 'SegmentAndSegmentProgression' && (
                    <ReportSegmentAndSegmentOfSegmentV2 type={listType} {...list} /> // WIP > Sewanti > CELESTIQ > Q2 > Executive Summary > 
                  )}

                  {!isPPTModalActive && list.InsightsElementType === 'SegmentDriversAnalysis' && (
                    <ReportSegmentV2 type={listType} {...list} /> // NEW component // MAHINDRA // XUV3XO > Brand Pulse, India || Intenders > Category Drivers
                  )}

                  {!isPPTModalActive && list.InsightsElementType === 'TopRelativeBrandsAnalysis' && (
                    <CompetitionConsideration type={listType} {...list} />
                  )}

                  {!isPPTModalActive && list.InsightsElementType === 'SegmentOfSegmentOverview' && (
                    <ReportSegmentAndSegmentOfSegmentV2 type={listType} {...list} /> // NEW Component
                  )}
                  {list.InsightsElementType === 'SegmentOfSegmentOverviewAndProgression' && (
                    <SegmentComparison type={listType} {...list} /> // NEW Component
                  )}

                  {list.InsightsElementType === 'CampaignSegmentsEngagementOverview' && (
                    <CampaignSegmentsEngagementOverview type={listType} {...list} />
                  )}
                  {list.InsightsElementType === 'CampaignSegmentsEngagementProgression' && (
                    <CampaignSegmentsEngagementProgression type={listType} {...list} />
                  )}
                  {list.InsightsElementType === 'InsightsMiningFrameworkWithSentiments' && (
                    <ReportMining type={listType} {...list} />
                  )}
                  {list.InsightsElementType === 'InsightsMiningFrameworkWithoutSentiments' && (
                    <ReportMining type={listType} {...list} />
                  )}
                  {!isPPTModalActive && list.InsightsElementType === 'SegmentAndSegmentOfSegment' && (
                    <ReportSegmentAndSegmentOfSegmentV2 type={listType} {...list} /> // NEW Component // Scorpio-N > Brand Pulse, India > Phase 2 FY25 > Customer Profile > Profile > Segment & Segment of Segment
                  )}

                  {list.InsightsElementType === '___DriversProgression' && (
                    <>
                      {/* VARTICAL BAR */}
                      <ReportSegment isDriversProgression hideTopBlueBar type={listType} {...list} />
                    </>
                  )}
                  {list.InsightsElementType === '___SearchDriversProgression' && (
                    <>
                      {/* VARTICAL BAR */}
                      <ReportSegment hideTopBlueBar isDriversProgression isSearchDrivers type={listType} {...list} />
                    </>
                  )}

                  {!isPPTModalActive && list.InsightsElementType === '___DriversProgressionWithoutSentiments' && (
                    <ReportSegmentV2 hideTopBlueBar isDriversProgression type={listType} {...list} />
                    // GAF // Residential >> Trends - Material > Trends Progression: Material
                  )}
                  {/* // {list.InsightsElementType === 'SegmentDriversOnlyAnalysisWithoutSentiments' && 
                  // list.InsightsElementId === '4fa0da74-6669-11ef-8482-128e718ba88f' && ( */}
                  {!isPPTModalActive && list.InsightsElementType === 'SegmentDriversOnlyAnalysisWithoutSentiments' && (
                    <ReportSegmentV2 hideTopBlueBar type={listType} {...list} />
                    // MAHINDRA // Scorpio-N > Brand Pulse > Phase 1 FY25 > Profile by Segments > Profile by City Tier > Past Ownership by City Tier
                  )}

                  {!isPPTModalActive && list.InsightsElementType === 'SegmentDriversOnlyAnalysisWithoutSentiments3Level' && (
                    <ReportSegmentV2 hideTopBlueBar type={listType} {...list} />
                    // <ComparisonViewDeepDiveV2 hideTopBlueBar type={listType} {...list} /> // NEW Component // WORKING DND
                  )}

                  {['Triangulation', 'TriangulationComparisonViewOnly'].includes(list.InsightsElementType) && (
                    <ReportSegment isDriversProgression hideTopBlueBar type={listType} {...list} /> // IMPORTANT DONT CHANGE AS DISCUSSED WITH ADITYA
                  )}

                  {list.InsightsElementType === 'CustomImage' && (
                    <ReportCustomImage type={listType} {...list} />
                  )}

                  {!isPPTModalActive && list.InsightsElementType === 'SegmentDriversOnlyAnalysis' && (
                    <ReportSegmentV2 hideTopBlueBar type={listType} {...list} /> // CivicPlus // Brand Health, USA > Category Analysis > Drivers Progression
                  )}

                  {list.InsightsElementType === 'MultiBrandNPS' && (
                    <MultiBrandNPS type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'CategoryPersona' && (
                    <ReportCategoryPersonaV2 type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'SegmentDriversOnlyAnalysis3Level' && (
                    <ReportSegmentV2 type={listType} {...list} />
                  )}

                  {/* BELOW 3 V1 are old version components */}
                  {list.InsightsElementType === 'DriversProgression3Level_v1' && (
                    <ComparisonViewDeepDiveV2 isDriversProgression hideTopBlueBar type={listType} {...list} /> // NEW Component // WORKING DND
                  )}
                  {list.InsightsElementType === 'DriversProgressionWithoutSentiments3Level_v1' && (
                    <ComparisonViewDeepDiveV2 hideTopBlueBar isDriversProgression type={listType} {...list} /> // NEW Component // WORKING DND
                  )}
                  {list.InsightsElementType === 'SearchDriversProgression3Level_v1' && (
                    <ComparisonViewDeepDiveV2 hideTopBlueBar isDriversProgression isSearchDrivers={true} type={listType} {...list} /> // NEW Component // WORKING DND
                  )}

                  {['DriversProgression', 'DriversProgression3Level'].includes(list.InsightsElementType) && (
                    <ComparisonViewDeepDiveNew isDriversProgression hideTopBlueBar type={listType} {...list} /> // THIS IS VERTICAL BAR
                  )}
                  {['SearchDriversProgression', 'SearchDriversProgression3Level'].includes(list.InsightsElementType) && (
                    <ComparisonViewDeepDiveNew hideTopBlueBar isDriversProgression isSearchDrivers={true} type={listType} {...list} /> // THIS IS VERTICAL BAR
                  )}
                  {['DriversProgressionWithoutSentiments', 'DriversProgressionWithoutSentiments3Level'].includes(list.InsightsElementType) && (
                    <ComparisonViewDeepDiveNew hideTopBlueBar isDriversProgression type={listType} {...list} /> // THIS IS VERTICAL BAR
                  )}

                  
                  {list.InsightsElementType === 'SegmentProgressionOverview' && (
                    <SegmentProgression type={listType} {...list} />
                  )}

                  {[
                    'BrandAttributeMapElement',
                    'BrandAttributeMapAndProgression',
                    'TriangulationMapElement',
                    'TriangulationMapAndProgression',
                    'TriangulationMapElementLog10',
                    'TriangulationMapAndProgressionLog10',
                  ].includes(list.InsightsElementType) && (
                    <ReportBrandAttributeMapElement type={listType} {...list} />
                  )}

                  {list.InsightsElementType === 'CustomTable' && (
                    <ReportCustomTable type={listType} {...list} />
                  )}
                </ContentWrapper>
              )}
              </ThemeProvider>

              {/* </ErrorBoundary> */}
              {isTourGuideActive && <TourGuide type='report' />}
            </ContentInnerWrapper>
          </React.Fragment>
        )
      })}
      <div id="driver-height-measurement-container" style={{ visibility: 'hidden', position: 'absolute', top: 0, left: 0, zIndex: -9999 }}>
        {/* Dynamically fill this later */}
      </div>
    </>
  )
}

export default Reports

ReportComponents.propTypes = {
  subLhs: PropTypes.array,
  pptSubLhs: PropTypes.array,
  csvSubLhs: PropTypes.array,
  isPPTModalActive: PropTypes.bool,
  isCSVModalActive: PropTypes.bool,
  lhsLoading: PropTypes.bool,
  loadOnlyApi: PropTypes.bool,
}

Reports.propTypes = {
  subLhs: PropTypes.array,
  pptSubLhs: PropTypes.array,
  csvSubLhs: PropTypes.array,
  isPPTModalActive: PropTypes.bool,
  isCSVModalActive: PropTypes.bool,
  lhsLoading: PropTypes.bool,
  loadOnlyApi: PropTypes.bool,
}

const ReportSnapshotWrapper = () => {
  const { setSnapshotModalActive, hasSnapshotData } = useGlobalStore()
  const closeSnapshotDetailPage = () => {
    setSnapshotModalActive(false)
  }
  const ActionButtons = () => {
    return (
      <>
        <Button
          className='button-back'
          size='small'
          onClick={() => closeSnapshotDetailPage()}
          variant='outlined'
        >
          <ArrowBackIos fontSize='8px' />
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Back</Typography>
        </Button>
      </>
    )
  }

  let hasSnapshotDataObject = hasSnapshotData
  if( !hasSnapshotDataObject ){ 
    hasSnapshotDataObject = JSON.parse(localStorage.getItem('snapshotData'))
  }
  // const listType = `${hasSnapshotData.InsightsElementType}__${hasSnapshotData.InsightsElementId.replaceAll('-', '')}__${0}`
  const listType = `${hasSnapshotDataObject.InsightsElementType}__${hasSnapshotDataObject.InsightsElementId.replaceAll('-', '')}`

  return (
    <AskIaLayout actionButtons={ActionButtons()}>
      <AskIaLayoutOuterWrapper>
        <ReportSnapshot type={listType} {...hasSnapshotData} visibility='visible' />
      </AskIaLayoutOuterWrapper>
    </AskIaLayout>
  )
}